import { useEffect } from "react";

import { useHandler } from "~/tools/use-handler";

import type { Monaco } from "../_monaco";

export function useOnEditorBlur(editor: null | Monaco.editor.IStandaloneCodeEditor, onBlur: VoidFunction): void {
	const onBlurStable = useHandler(onBlur);

	useEffect(() => {
		const disposable = editor?.onDidBlurEditorText(onBlurStable);

		return () => {
			disposable?.dispose();
		};
	}, [editor, onBlurStable]);
}
